<template>
    <div>
        <div class="row mt-5 mb-5">
            <div class="col-lg-12">
                <div class="d-flex justify-content-between align-items-center">
                    <p class="title-biblioteca text-bold">
                        Videos y tutoriales
                    </p>
                </div>
            </div>
            <div class="mb-3 d-flex justify-content-center flex-column align-items-center" v-if="false">
                <label for="exampleFormControlInput1" class="form-label">Buscar un video </label>
                <input type="email" class="form-control" id="exampleFormControlInput1" placeholder="Escribe algo ..."
                    v-model="search" style="width: 35%;">
            </div>
            <div class="col-12 col-md-6 col-lg-6" v-for="{ id, enlaceImagen, enlaceVideo, titulo } in videosFilter" :key="id">
                <div class="card shadow">
                    <h6 class="text-start mt-4 ms-3 text-bold">{{ titulo }}</h6>
                    <div class="card-body">
                        <video controls :poster="enlaceImagen">
                            <source :src="enlaceVideo" type="video/mp4" />
                        </video>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center mt-3" v-if="videos.length > 2">
                <button class="button" @click="loadMore()" v-if="videos.length > itemsToShow">Cargar más</button>
                <button class="button" @click="resetItemsShow()" v-else>Cargar menos</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        videos: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            search: '',
            itemsToShow: 2,
        }
    },
    computed: {
        videosFilter() {
            const search = this.search.toLowerCase();
            const filteredVideos = this.videos.filter(manual => {
                return manual.titulo.toLowerCase().includes(search);
            }).slice(0, this.itemsToShow);
            return filteredVideos;
        },
    },
    methods: {
        loadMore() {
            this.itemsToShow += 4;
        },
        resetItemsShow() {
            this.itemsToShow = 2
        }
    }

}
</script>

<style lang="scss" scoped>
.button {
    background-color: #b8725a !important;
    color: white;
    border-radius: 5px;
    border: 0;
    font-size: 14px;
    padding: 10px;
    max-width: 260px;
    width: 150px;
    text-decoration: none;
}
video {
    width: 100%; 
    height: 320px;
}
.card{
    padding: 10px;
     height: 420px;
}
@media only screen and (max-width: 1024px) {
  video {
    height:160px ;
    width: 100%;
  }
  .card{
    height: auto;

  }
}
</style>